var development = process.env.NODE_ENV == "development";

var config = {
  getMode: () => {
    return development;
  },

  getTestMail: () => {
    return development ? "dgreipl@haw-landshut.de" : "";
  },

  getTestPassword: () => {
    return development ? "123456" : "";
  },

  getTestTrue: opsValue => {
    return development ? true : opsValue;
  },

  getBaseUrl: () => {
    return development
      ? "http://localhost:8080/"
      : "https://greipl24.firebaseapp.com/";
  },

  getSettings: () => {
    return {
      semester: "ws2122",
      tables: {
        klausur_einsicht: "KE_SS22",
        sap_accounts:"S4_M29_462"
      }
    }
    
  }

};

export { config };
